import { QuestLog, QuestLogItem } from 'components/Docs/QuestLog';
import { IconGraph, IconWarning, IconRewindPlay } from '@posthog/icons';
import LLMsInstallationPlatforms from "../../../../contents/docs/llm-analytics/_snippets/llms-installation-platforms.tsx";
import OSButton from 'components/OSButton';
import * as React from 'react';
export default {
  QuestLog,
  QuestLogItem,
  IconGraph,
  IconWarning,
  IconRewindPlay,
  LLMsInstallationPlatforms,
  OSButton,
  React
};